import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { UITypes } from "types"

interface Props {
  cell?: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
  status?: string
}

interface StatusSpanProps {
  statusType: string
}

const StatusSpan = styled.span<StatusSpanProps>`
  padding: 2px 8px;
  text-transform: uppercase;
  border-radius: 20px;
  line-height: 1;
  position: relative;
  font-size: 12px;
  display: inline-flex;
  align-items: center;

  ${({ statusType }) => {
    switch (statusType) {
      case "1":
        return `
          border: 1px solid #14b8a6;
          background: #dffbf4;
          color: #115e59;
        `
      case "0":
        return `
          border: 1px solid #fcceee;
          background: #fdf2fa;
          color: #c11574;
        `
      default:
        return ""
    }
  }}
`

export const StatusOfContractorUser = ({ cell, status }: Props) => {
  const type = cell?.getValue().value ? String(cell.getValue().value) : status
  let label = ""

  switch (type) {
    case "1":
      label = "Active"
      break

    case "0":
      label = "Disabled"
      break

    default:
      label = type ? String(type) : ""
      break
  }

  return <StatusSpan statusType={type || ""}>{label}</StatusSpan>
}
